import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { fadeUp, viewportOnce } from './Animations';
import { program } from '@/lib/program-data';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faqs" className="py-12 bg-white">
      <div className="container-content max-w-3xl">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={fadeUp}
          className="text-center"
        >
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-edept-orange">FAQs</p>
          <h2 className="mt-3 text-3xl text-edept-dark sm:text-4xl">Common questions</h2>
        </motion.div>

        <div className="mx-auto mt-10 max-w-5xl">
          <div className="mt-10 divide-y divide-edept-light-gray">
            {program.faqs.map((faq, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div key={faq.q} className="py-4">
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 text-left"
                  >
                    <span className="text-base font-semibold text-slate-900">{faq.q}</span>
                    <ChevronDown
                      aria-hidden="true"
                      className={`shrink-0 text-edept-dark transition-transform ${isOpen ? 'rotate-180' : ''}`}
                      size={20}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.25 }}
                        className="overflow-hidden"
                      >
                        <p className="pt-3 text-base leading-relaxed text-slate-600">{faq.a}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
